import { render, staticRenderFns } from "./navjxzx.vue?vue&type=template&id=1bbda575&scoped=true&"
import script from "./navjxzx.vue?vue&type=script&lang=js&"
export * from "./navjxzx.vue?vue&type=script&lang=js&"
import style0 from "./navjxzx.vue?vue&type=style&index=0&id=1bbda575&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbda575",
  null
  
)

export default component.exports